{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Stack Maps ID",
      "folder": "Unit Header",
      "width": 200,
      "tnum": true,
    },
  },
  "agreement_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement No.",
      "folder": "Unit Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Unit Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "unit_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Name",
      "folder": "Unit Header",
      "width": 170,
      "isShownByDefault": true,
    },
  },
  "production_entity_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Production Entity ID",
      "folder": "Unit Header",
      "subFolder": "AB Header",
      "tnum": true,
    },
  },
  "production_entity_crown_percent": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Crown Percent",
      "folder": "Unit Header",
      "subFolder": "AB Header",
    },
  },
  "production_entity_freehold_percent": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Freehold Percent",
      "folder": "Unit Header",
      "subFolder": "AB Header",
    },
  },
  "participants": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Participants",
      "folder": "Unit Header",
      "width": 200,
      "isShownByDefault": true,
    },
  },
  "operator": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Operator",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "unit_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "unit_area": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area",
      "folder": "Unit Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "unit_effective_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Effective Date",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "unit_execution_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Execution Date",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "unit_termination_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Termination Date",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "last_update_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Update Date",
      "folder": "Unit Header",
      "isShownByDefault": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
